////////////////////////////////////////////
// MENU — DROPDOWN PANEL + ROW PRIMITIVES
////////////////////////////////////////////
//
// RENDER MenuPanel INSIDE A relative WRAPPER (PAIR WITH useDismiss FOR
// OUTSIDE-CLICK/ESCAPE). PLACEMENTS:
//   anchor — DROPDOWN ANCHORED UNDER THE TRIGGER (ALL VIEWPORTS)
//   sheet  — MOBILE BOTTOM SHEET (FIXED, SAFE-AREA PADDED, SCROLLABLE),
//            ANCHORED DROPDOWN FROM lg UP. NOT DRAGGABLE ON PURPOSE, SO NO
//            GRABBER IS SHOWN (A HANDLE WOULD PROMISE RESIZING) — SCRIM
//            TAP, ESCAPE, OR AN ACTION DISMISSES IT.
// MenuItem ROWS KEEP COMFORTABLE TOUCH HEIGHT ON MOBILE; selected DRAWS
// THE CURRENT-PICK OUTLINE.
import type { ButtonHTMLAttributes, HTMLAttributes } from "react";

const SKIN = "z-60 bg-panel border border-line";

const PLACEMENT = {
  anchor:
    "absolute top-[calc(100%+8px)] right-0 rounded-xl p-[6px] shadow-[0_14px_32px_rgba(0,0,0,.55)]",
  sheet:
    "fixed inset-x-0 bottom-0 rounded-t-2xl border-x-0 border-b-0 " +
    "p-[10px] pb-[calc(14px+env(safe-area-inset-bottom))] max-h-[75dvh] overflow-y-auto overscroll-contain " +
    "shadow-[0_-18px_44px_rgba(0,0,0,.6)] " +
    "lg:absolute lg:inset-x-auto lg:bottom-auto lg:top-[calc(100%+8px)] lg:right-0 " +
    "lg:rounded-xl lg:border lg:p-[6px] lg:max-h-none lg:overflow-visible " +
    "lg:shadow-[0_14px_32px_rgba(0,0,0,.55)]",
};

export function MenuPanel({ className, placement = "anchor", ...props }: HTMLAttributes<HTMLDivElement> & { placement?: keyof typeof PLACEMENT }) {

  return (
    <div
      role="menu"
      className={SKIN + " " + PLACEMENT[placement] + (className ? " " + className : "")}
      {...props}
    />
  );
}

export function MenuItem({ className, selected, ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { selected?: boolean }) {

  return (
    <button
      type="button"
      role="menuitem"
      className={
        "flex items-center gap-[10px] w-full px-[10px] py-[11px] lg:py-[9px] rounded-[9px] text-left " +
        "hover:bg-white/6 cursor-pointer" +
        (selected ? " outline outline-1 -outline-offset-1 outline-line" : "") +
        (className ? " " + className : "")
      }
      {...props}
    />
  );
}
